import axios from "axios";
import _ from "lodash";
import Endpoint from "../../constant/endpoint";
const token =
  // "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxIiwic2NwIjoidXNlciIsImF1ZCI6bnVsbCwiaWF0IjoxNjAwNzY5ODIxLCJleHAiOjI3MjY2ODA3Mjk3ODIxLCJqdGkiOiI4MzMzNzM5OS0yNGM2LTQ4Y2ItYjhhOS1mYzFkOGY4Y2YxMjEifQ.6X7L2vrFS37k8hKsZ-4Vg7CsApI-rVLnxMcOa8vp3Lg"
  "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxIiwic2NwIjoidXNlciIsImF1ZCI6bnVsbCwiaWF0IjoxNjAwOTMxNTY0LCJleHAiOjI3MjY2ODA3NDU5NTY0LCJqdGkiOiIzZmFiNGNmYi1hMDdiLTRiMmQtYjQyNS1iMjc3ZTQwOTU4NjYifQ.wtKq6vcox5SHLsydNh6fme-5QuIbg3EPt29X-QgC59E";
const state = {
  loading: false,
  error: {},
  vesselData: [],
  transferLogs: [],
  transferLogsByConfig: [],
  transferLogsByVessel: [],
  tankers: [],
  vessels: [],
  stations: [],
};

const getters = {
  getVesselAll: (state) => {
    return state.vesselData;
  },

  getTransferLogs: (state) => (id) => {
    return _.filter(state.transferLogs,{"forward_id":id});
  },
};

const actions = {
  // action
  setMpTankers(context, tankers) {
    context.commit("SET_MP_TANKER", tankers);
  },
  getMpAllStations(context) {
    $.ajax({
      url: Endpoint.mpStations(),
      type: "GET",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", `Bearer ${token}`);
      },
      success: (result) => {
        const data = result;
        context.commit("SUCCESS_STATIONS_ALL", { data });
      },
      error: (e) => {
        context.commit("ERROR_VESSEL_DATA", { error: e });
      },
      complete: () => {
        // complete
      },
    });
  },
  getMpVesselAll(context) {
    $.ajax({
      url: Endpoint.vesselTanker(),
      type: "GET",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", `Bearer ${token}`);
      },
      success: (result) => {
        const data = result;
        // context.commit("SUCCESS_VESSEL_DATA", { data });
      },
      error: (e) => {
        context.commit("ERROR_VESSEL_DATA", { error: e });
      },
      complete: () => {
        // complete
      },
    });
  },

  async getMPTankerByMMSI(context, id) {
    const url = Endpoint.mpVessels();
    const config = {
      params: {
        "q[id_eq]": id,
      },
    };
    await axios
      .get(url, config)
      .then((res) => {
        const data = _.get(res, "data", []).map((a) => {
          return {
            id: a.id,
            name: a.name,
          };
        });
        if (data.length > 0) {
          context.commit("SUCCESS_MP_VESSEL", { data });
        } else {
          context.commit("NOT_FOUND_VESSEL_TRIP");
        }
      })
      .catch((e) => {
        context.commit("ERROR_VESSEL_ALL", { error: e });
      })
      .finally(() => {
        context.commit("LOADING_VESSEL_ALL", { loading: false });
      });
  },
  async getMpTranferLogs(context, data) {
    const url = Endpoint.transferLogs();
    const config = {
      params: {
        "q[tanker_id_eq]": data.tankerId,
        "q[forward_tanker_id_eq]": data.forwardTankerId,
        "q[transfer_date_gteq]": data.startDate,
        "q[transfer_date_lteq]": data.endDate,
        "q[vessel_id_null]": data.vesselNull,
      },
    };
    await axios
      .get(url, config)
      .then(async(res) => {
        const data = _.get(res, "data", []).map((a) => {
          return {
            id: a.id,
            forward_id: a.forward_tanker_id,
            forward_name: tanker.name,
            mmsi: tanker.mmsi,
            vessel_id: a.vessel_id,
            tanker_id: a.tanker_id,
            volume: a.volume,
            station_id: a.station_id,
            transfer_date: a.transfer_date,
            start_at: a.start_at
          };
        });
        if (data.length > 0) {
          await context.commit("SUCCESS_TRANSFER_LOGS_BY_CONFIG", { data });
        }
      })
      .catch((e) => {
        context.commit("ERROR_VESSEL_ALL", { error: e });
      })
      .finally(() => {
        context.commit("LOADING_VESSEL_ALL", { loading: false });
      });
  },
  async getMpTranferLogsByVessel(context, data) {
    const url = Endpoint.transferLogs();
    const config = {
      params: {
        "q[tanker_id_eq]": data.tankerId,
        "q[forward_tanker_id_eq]": data.forwardTankerId,
        "q[transfer_date_gteq]": data.startDate,
        "q[transfer_date_lteq]": data.endDate,
        "q[vessel_id_null]": data.vesselNull,
      },
    };
    await axios
      .get(url, config)
      .then(async(res) => {
        const data = _.get(res, "data", []).map((a) => {
          return {
            id: a.id,
            forward_id: a.forward_tanker_id,
            forward_name: tanker.name,
            mmsi: tanker.mmsi,
            vessel_id: a.vessel_id,
            tanker_id: a.tanker_id,
            volume: a.volume,
            station_id: a.station_id,
            transfer_date: a.transfer_date,
            start_at: a.start_at
          };
        });
        if (data.length > 0) {
          await context.commit("SUCCESS_TRANSFER_LOGS_BY_VESSEL", { data });
        }
      })
      .catch((e) => {
        context.commit("ERROR_VESSEL_ALL", { error: e });
      })
      .finally(() => {
        context.commit("LOADING_VESSEL_ALL", { loading: false });
      });
  },
  async getMpTransferLogsAll(context,option) {
    const url = Endpoint.transferLogs();
    const config = {
      params: {
        "q[transfer_date_gteq]": option.startDate,
        "q[transfer_date_lteq]": option.endDate,
        "q[forward_tanker_id_null]": false,
      },
    };
    await axios
      .get(url, config)
      .then((res) => {
        const data = _.get(res, "data", []).map((a) => {
          const forward_tanker = context.getters.getTankerbyID(
            a.forward_tanker_id
          );
          const tanker = context.getters.getTankerbyID(a.tanker_id);
          if (!_.isUndefined(tanker)) {
            return {
              id: a.id,
              forward_id: a.forward_tanker_id,
              forward_name: forward_tanker.name,
              mmsi: forward_tanker.mmsi,
              vessel_id: a.vessel_id,
              tanker_id: a.tanker_id,
              tanker_name: tanker.name_en,
              volume: a.volume,
              transfer_date: a.transfer_date,
            };
          }
        });
        const withOutData = _.without(data, undefined);
        withOutData.forEach(log =>{
          const v = {id: log.tanker_id,...option}
          context.dispatch('getMpTransferLogsVessel',v)
        })

        if (withOutData.length > 0) {
          context.commit("SUCCESS_TRANSFER_LOGS",  withOutData );
        } else {
          context.commit("NOT_FOUND_TRANSFER_LOGS");
        }
      })
      .catch((e) => {
        context.commit("ERROR_VESSEL_ALL", { error: e });
      })
      .finally(() => {
        context.commit("LOADING_VESSEL_ALL", { loading: false });
      });
  },
  async getMpTransferLogsVessel(context,option) {
    const url = Endpoint.transferLogs();
    const config = {
      params: {
        "q[transfer_date_gteq]": option.startDate,
        "q[transfer_date_lteq]": option.endDate,
        "q[tanker_id_eq]": option.id,
        "q[vessel_id_null]": false
      },
    };
    await axios
      .get(url, config)
      .then((res) => {
        const data = _.get(res, "data", []).map((a) => {
        //   const forward_tanker = context.getters.getTankerbyID(
        //     a.forward_tanker_id 
        //   );
        //   const tanker = context.getters.getTankerbyID(a.tanker_id);
        //   if (!_.isUndefined(tanker)) {
            return {
              id: a.id,
              vessel_id: a.vessel_id,
              tanker_id: a.tanker_id,
              volume: a.volume,
              transfer_date: a.transfer_date,
            };
          
        });
        const withOutData = _.without(data, undefined);
        if (withOutData.length > 0) {
          context.commit("SUCCESS_MP_TRANSFER_LOGS_BY_VESSEL",  withOutData );
        } else {
          context.commit("NOT_FOUND_TRANSFER_LOGS");
        }
      })
      .catch((e) => {
        context.commit("ERROR_VESSEL_ALL", { error: e });
      })
      .finally(() => {
        context.commit("LOADING_VESSEL_ALL", { loading: false });
      });
  },
};

const mutations = {
  // mutations
  SUCCESS_STATIONS_ALL(state, payload) {
    state.stations = payload.data;
  },
  SUCCESS_VESSEL_ALL(state, payload) {
    state.vesselData = payload.data;
  },
  SUCCESS_MP_VESSEL(state, payload) {
    state.vessels.push(payload.data);
  },
  SUCCESS_MP_TANKER(state, payload) {
    state.tankers.push(...payload.data);
    state.tankers = _.uniqBy(state.tankers, "id");
  },
  SUCCESS_MP_TRANSFER_LOGS_BY_VESSEL(state, payload) {
    state.transferLogsByVessel.push(...payload.data);
    state.transferLogsByVessel = _.uniqBy(state.transferLogsByVessel, "id");
  },
  SUCCESS_TRANSFER_LOGS(state, payload) {
    state.transferLogs = payload;
  },
  SUCCESS_TRANSFER_LOGS_BY_CONFIG(state, payload) {
    state.transferLogsByConfig = payload.data;
  },
  SUCCESS_TRANSFER_LOGS_BY_VESSEL(state, payload) {
    state.transferLogsByVessel = payload.data;
  },
  NOT_FOUND_TRANSFER_LOGS(state) {
    state.transferLogs = [];
    // state.transferLogs.push(...payload.data);
  },
  ERROR_VESSEL_ALL(state, payload) {
    state.error = {
      ...payload,
    };
  },
  LOADING_VESSEL_ALL(state, payload) {
    state.loading = payload.loading;
  },
  SET_MP_TANKER(state, payload) {
    state.tankers = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
